<script setup lang="ts">
defineOptions({ name: "App" });

import { RouterView } from "vue-router";

import { Sonner } from "@/shared/ui/shadcn/sonner";
</script>

<template>
  <RouterView />
  <Sonner />
</template>
